import React from 'react';
import { formatDistanceToNow } from 'date-fns';
import { Avatar, AvatarFallback, AvatarImage } from './ui/avatar';
import { Badge } from './ui/badge';
import { userAPI } from '../utils/api';

const Sidebar = ({ channels, selectedChannel, onSelectChannel, users, currentUser }) => {
  const getChannelDisplay = (channel) => {
    if (channel.channel_type === 'direct') {
      const otherParticipantId = channel.participants.find(p => p !== currentUser?.id);
      // First try participant_details from the channel (always accurate)
      const detail = channel.participant_details?.find(p => p.id === otherParticipantId);
      // Fall back to users list (contacts)
      const user = detail || users.find(u => u.id === otherParticipantId);
      return {
        name: user?.name || 'Unknown User',
        avatar: user?.name?.charAt(0).toUpperCase() || '?',
        avatarUrl: user?.avatar_url ? userAPI.getAvatarUrl(user.avatar_url) : null,
        status: user?.status || 'offline',
      };
    } else {
      return {
        name: channel.name || 'Group Chat',
        avatar: 'G',
        avatarUrl: null,
        status: null,
      };
    }
  };

  return (
    <div className="p-4 space-y-2" data-testid="sidebar">
      {channels.length === 0 ? (
        <p className="text-center text-[#94A3B8] text-sm py-8">No chats yet</p>
      ) : (
        channels.map((channel) => {
          const display = getChannelDisplay(channel);
          const isSelected = selectedChannel?.id === channel.id;

          return (
            <div
              key={channel.id}
              onClick={() => onSelectChannel(channel)}
              className={`flex items-center gap-3 p-3 rounded-md cursor-pointer transition-all duration-200 hover-lift ${
                isSelected ? 'bg-white border border-[#4338CA]' : 'hover:bg-white'
              }`}
              data-testid={`channel-item-${channel.id}`}
            >
              <div className="relative">
                <Avatar>
                  <AvatarImage src={display.avatarUrl} />
                  <AvatarFallback className="bg-[#4338CA] text-white">
                    {display.avatar}
                  </AvatarFallback>
                </Avatar>
                {display.status && (
                  <div
                    className={`absolute bottom-0 right-0 w-3 h-3 rounded-full border-2 border-white ${
                      display.status === 'online' ? 'status-online' : 'status-offline'
                    }`}
                    data-testid={`status-indicator-${channel.id}`}
                  />
                )}
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-medium text-[#0F172A] truncate">{display.name}</p>
                {channel.last_message && (
                  <p className="text-sm text-[#94A3B8] truncate">
                    {formatDistanceToNow(new Date(channel.last_message), { addSuffix: true })}
                  </p>
                )}
              </div>
            </div>
          );
        })
      )}
    </div>
  );
};

export default Sidebar;
